module.exports = __webpack_public_path__ + "img/paypwd.b3b05b1a.svg";